import React, { useState } from 'react';
import api from '../api';

const MAX_ABSENCES = 3;

export default function SubjectCard({ subject, onUpdate, onDelete }) {
  const [loading, setLoading] = useState(false);

  const handleAbsence = async (action) => {
    if (loading) return;
    setLoading(true);
    try {
      const res = await api.patch(`/subjects/${subject.id}/absence`, { action });
      onUpdate(res.data);
    } catch (err) {
      console.error('Absence update error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (loading) return;
    if (!window.confirm(`Törlöd a(z) "${subject.name}" tárgyat?`)) return;
    setLoading(true);
    try {
      await api.delete(`/subjects/${subject.id}`);
      onDelete(subject.id);
    } catch (err) {
      console.error('Delete error:', err);
    } finally {
      setLoading(false);
    }
  };

  const absences = subject.absences;
  const isFull = absences >= MAX_ABSENCES;
  const isEmpty = absences === 0;

  return (
    <div className={`subject-card ${isFull ? 'subject-card--full' : ''}`}>
      <div className="subject-header">
        <h2 className="subject-name">{subject.name}</h2>
        <button
          className="delete-btn"
          onClick={handleDelete}
          disabled={loading}
          title="Tárgy törlése"
          aria-label="Tárgy törlése"
        >
          ×
        </button>
      </div>

      <div className="absence-section">
        <p className="absence-label">Hiányzások</p>
        <div className="absence-dots">
          {Array.from({ length: MAX_ABSENCES }, (_, i) => (
            <span
              key={i}
              className={`absence-dot ${i < absences ? 'absence-dot--used' : ''}`}
            />
          ))}
        </div>
        <p className="absence-count">
          {absences} / {MAX_ABSENCES}
          {isFull && <span className="absence-warning"> – Megtelt!</span>}
        </p>
      </div>

      <div className="absence-actions">
        <button
          className="btn btn--decrement"
          onClick={() => handleAbsence('decrement')}
          disabled={loading || isEmpty}
          title="Visszavonás"
        >
          − Visszavon
        </button>
        <button
          className="btn btn--increment"
          onClick={() => handleAbsence('increment')}
          disabled={loading || isFull}
          title="Hiányzás hozzáadása"
        >
          + Hiányzás
        </button>
      </div>
    </div>
  );
}
